module.exports = __webpack_public_path__ + "static/media/BetterShirt.c31d2d97.mtl";


//////////////////
// WEBPACK FOOTER
// ./src/3dmodels/Tshirt1/BetterTShirt/BetterShirt.mtl
// module id = 82
// module chunks = 0